import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import PortfolioContent from './components/PortfolioContent'

function Portfolio() {
  useEffect(() => {
    document.title = 'Dorac - Portfólio'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <PortfolioContent />
      <Footer />
    </main>
  )
}

export default Portfolio
